import { Col, Row, message, Select, Typography, Divider, Alert } from "antd";
import React, { useEffect, useState } from "react";
import { Button, Card, Form, Input } from "antd";
import { useDispatch } from "react-redux";
import { useHistory, useLocation } from "react-router-dom";
import { addUser, fetchOneUser, updateUser } from "redux/features/user";
import Password from "antd/lib/input/Password";

const STATUS_OPTIONS = [
  { label: "Active", value: true },
  { label: "Inactive", value: false },
];

const selectStyle = {
  width: "100%",
  backgroundColor: "white",
};

const rules = [
  {
    required: true,
    message: "Wajib Diisi!",
  },
];

export const USER = () => {
  const dispatch = useDispatch();
  const history = useHistory();
  const [form] = Form.useForm();
  const location = useLocation();
  const { Option } = Select;

  const [body, setBody] = useState("");
  const [role, setRole] = useState("user");

  const handleChange = (value) => {
    setRole(value);
  };

  const onFinish = (values) => {
    if (location?.state?.id) {
      updateData(values);
    } else {
      createData(values);
    }
  };

  const createData = async (values) => {
    try {
      await dispatch(addUser(values)).unwrap();
      message.success("Membuat user baru berhasil!");
      setTimeout(() => {
        history.push("/app/users");
      }, 1500);
    } catch (error) {
      message.error(error?.message || "Failed to register");
    }
  };

  const updateData = async (values) => {
    try {
      await dispatch(
        updateUser({ ...values, id: location?.state?.id })
      ).unwrap();
      message.success("Update berhasil!");
      setTimeout(() => {
        history.push("/app/users");
      }, 1500);
    } catch (error) {
      message.error(error?.message || "Failed to fetch data");
    }
  };

  const onFinishFailed = (errorInfo) => {
    console.log("Failed:", errorInfo);
  };

  const getDataById = async (id) => {
    try {
      const data = await dispatch(fetchOneUser(id)).unwrap();
      form.setFieldsValue({
        ...data.data,
      });
    } catch (err) {
      console.log(err);
    }
  };

  useEffect(() => {
    if (location?.state?.id) {
      getDataById(location?.state?.id);
    }
  }, []);

  const rolesDummy = [
    { id: 1, label: "Admin", value: "admin" },
    { id: 2, label: "Operator", value: "operator" },
    { id: 3, label: "Protocol", value: "protocol" },
    { id: 4, label: "Dewan", value: "dewan" },
  ];

  const layout = {
    labelCol: {
      xs: { span: 24 },
      sm: { span: 8 },
      md: { span: 6 },
      lg: { span: 5 },
      xl: { span: 4 },
    },
    wrapperCol: {
      xs: { span: 24 },
      sm: { span: 16 },
      md: { span: 18 },
      lg: { span: 19 },
      xl: { span: 20 },
    },
  };

  return (
    <>
      <Row gutter={24}>
        <Col xs={24} sm={24} md={24} lg={24}>
          <h2>Tambah/Update Pengguna</h2>
          <p>Please fill your data</p>
        </Col>
      </Row>
      <Row gutter={24}>
        <Col xs={24} sm={24} md={24} lg={24}>
          <Card>
            <Form
              name="basic"
              form={form}
              onFinish={onFinish}
              onFinishFailed={onFinishFailed}
              autoComplete="off"
              labelAlign="right"
              {...layout}
            >
              <Typography.Title level={5}>Profil Pengguna</Typography.Title>

              <Form.Item
                label="Username"
                name="username"
                rules={[
                  {
                    required: true,
                    message: "Please input your username!",
                  },
                ]}
              >
                <Input />
              </Form.Item>

              <Form.Item
                label="Email"
                name="email"
                rules={[
                  {
                    required: true,
                    message: "Please input your email!",
                  },
                ]}
              >
                <Input />
              </Form.Item>
              <Form.Item
                label="Nomor HP (WA)"
                name="no_phone"
                rules={[
                  {
                    required: true,
                    message: "Please input your no_phone!",
                  },
                ]}
              >
                <Input />
              </Form.Item>

              <Form.Item label="Role" name="role_id">
                <Select placeholder="Pilih Role">
                  {rolesDummy.map((role) => (
                    <Option key={role.id} value={role.id}>
                      {role.label}
                    </Option>
                  ))}
                </Select>
              </Form.Item>

              <Divider />
              <Form.Item>
                <Typography.Title level={5}>Keamanan Pengguna</Typography.Title>
              </Form.Item>

              <Form.Item label="Password" name="password" rules={[]}>
                <Password />
              </Form.Item>

              <Form.Item
                label="Confirm Password"
                name="confirmPassword"
                dependencies={["password"]}
                rules={[
                  ({ getFieldValue }) => ({
                    validator(_, value) {
                      if (!value || getFieldValue("password") === value) {
                        return Promise.resolve();
                      }
                      return Promise.reject(
                        new Error("Konfirmasi password tidak cocok!")
                      );
                    },
                  }),
                ]}
              >
                <Input.Password />
              </Form.Item>

              <Form.Item label="Status" name="isActive">
                <Select placeholder="Status">
                  <Option key={1} value={true}>
                    Aktif
                  </Option>
                  <Option key={2} value={false}>
                    Tidak Aktif
                  </Option>
                </Select>
              </Form.Item>

              <Form.Item wrapperCol={24}>
                <Button
                  type="primary"
                  htmlType="submit"
                  style={{ width: "100%" }}
                >
                  Submit
                </Button>
              </Form.Item>
              <Form.Item>
                <Alert
                  message="Catatan"
                  description="Hanya admin yang bisa mengubah status user. User biasa hanya bisa mengaktifkan akun melalui konfirmasi email."
                  type="info"
                  showIcon
                />
              </Form.Item>
            </Form>
          </Card>
        </Col>
      </Row>
    </>
  );
};

export default USER;
